import React, { useState } from 'react';
import Loader from '../loader/loader.component';
import './google-doc-viewer.style.scss';

const GoogleDocViewer = ({ docId, height }: { docId: string; height?: number }) => {
  const [loading, setLoading] = useState(true);

  return (
    <Loader loading={loading}>
      <div className="googleDocViewer" style={{ height: height ? `${height}px` : '100vh' }}>
        <iframe
          src={`https://docs.google.com/document/d/${docId}/preview`}
          title="Google Document Viewer"
          allowFullScreen
          onLoad={() => setLoading(false)}
        ></iframe>
      </div>
    </Loader>
  );
};

export default GoogleDocViewer;
